import { GET_ALL_EVENTS, GET_ALL_EVENTS_RESPONSE_SUCCESS } from "./actionTypes"

export const getAllEvents = () => {
  return {
    type: GET_ALL_EVENTS,
  }
}
export const getAllEventsResponseSuccess = payload => ({
  type: GET_ALL_EVENTS_RESPONSE_SUCCESS,
  payload: payload,
})
